import Vue from "vue";

import Navigation from "@/components/partials/Navigation";
import Jumbotron from "@/components/partials/Jumbotron";
import ActiveSelections from "@/components/partials/ActiveSelections";
import AppLoader from "@/components/partials/AppLoader";

Vue.component('navigation', Navigation);
Vue.component('jumbotron', Jumbotron);
Vue.component('active-selections', ActiveSelections);
Vue.component('app-loader', AppLoader);


// WEBPACK FOOTER //
// ./src/components/partials/index.js